export default {"src":"/_next/static/media/extract-lineage-information.d514cd7d.svg","height":200,"width":225,"blurWidth":0,"blurHeight":0};